import {useMemo} from 'react'
import {useFloating} from '../../../../floating/hooks'
import {useCloseDropdownOnItemClick} from './use_close_dropdown_on_item_click'
import {useOpenAtCursorPosition} from './use_open_at_cursor_position'

export const useDropdown = ({placement = 'right-start', triggerEvent, openAtCursorPosition, isNested, maxHeight, triggerDisabled}) => {
	const floating = useFloating({placement, maxHeight})

	const {isOpen, setIsOpen, context} = floating

	useCloseDropdownOnItemClick({isOpen, setIsOpen})

	const defaultTriggerEvent = isNested ? 'hover' : 'click'
	triggerEvent = triggerEvent || defaultTriggerEvent

	const triggerHoverEnabled = triggerEvent === 'hover'

	const cursorPosition = useOpenAtCursorPosition(context, {
		enabled: !!openAtCursorPosition,
		axis: openAtCursorPosition,
	})

	const config = useMemo(
		() => ({
			hover: {enabled: triggerHoverEnabled},
			click: {ignoreMouse: triggerHoverEnabled},
			disabled: triggerDisabled,
		}),
		[triggerHoverEnabled, triggerDisabled],
	)

	const interactions = useMemo(() => [cursorPosition], [cursorPosition])

	return useMemo(
		() => ({
			floating,
			config,
			interactions,
		}),
		[floating, config, interactions],
	)
}
